var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 48,
    height: 48,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47878 17.5423L4.21533 12.2789L5.03071 11.4731L9.47878 15.9212L18.9538 6.43658L19.7691 7.25193L9.47878 17.5423Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneFill);
export default __webpack_public_path__ + "static/media/done-fill.e4e2f1ab190a18fb3936ff9e64a73d60.svg";
export { ForwardRef as ReactComponent };